import { render, staticRenderFns } from "./Gift_TouSu2_Dtl.vue?vue&type=template&id=258066f6&scoped=true"
import script from "./Gift_TouSu2_Dtl.vue?vue&type=script&lang=js"
export * from "./Gift_TouSu2_Dtl.vue?vue&type=script&lang=js"
import style0 from "./Gift_TouSu2_Dtl.vue?vue&type=style&index=0&id=258066f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258066f6",
  null
  
)

export default component.exports